import React from "react";
import { useStyles } from "../AssetNonTitled/AssetNonTitledFormStyles";
import {
    Grid,
    Select,
    FormControl,
    MenuItem,
    InputLabel,
    TextField
} from "@material-ui/core";
import { actions } from "../AssetReducer";

export default function ManualOverrideDetails({ asset, conditions, dispatch }) {
    const classes = useStyles();

    return (
        <Grid item xs={12}>
            <Grid item xs={12}>
                <FormControl className={classes.formControl} style={{ width: "100%" }}>
                    <InputLabel id="override-year-label">Override Year</InputLabel>
                    <Select
                        style={{ width: "100%" }}
                        id="override-year-select"
                        labelId="override-year-label"
                        value={asset.override_year || ""}
                        onChange={(e) => {
                            dispatch({
                                type: actions.OVERRIDE_YEAR,
                                payload: e.target.value,
                            });
                        }}>
                        {conditions.yearChoices &&
                            conditions.yearChoices.map((year) => (
                                <MenuItem key={year} value={year}>
                                    {year}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    style={{ width: "100%" }}
                    id="override-category"
                    label="Override Category"
                    value={asset.pd_override_category || ""}
                    margin="normal"
                    onChange={(e) => {
                        dispatch({
                            type: actions.PD_OVERRIDE_CATEGORY,
                            payload: {
                                categoryId: null,
                                categoryName: e.target.value,
                            },
                        });
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    style={{ width: "100%" }}
                    id="override-make"
                    label="Override Make"
                    value={asset.override_make || ""}
                    margin="normal"
                    onChange={(e) =>
                        dispatch({
                            type: actions.OVERRIDE_MAKE,
                            payload: e.target.value,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    style={{ width: "100%" }}
                    id="override-model"
                    label="Override Model"
                    value={asset.override_model || ""}
                    margin="normal"
                    onChange={(e) =>
                        dispatch({
                            type: actions.OVERRIDE_MODEL,
                            payload: e.target.value,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    style={{ width: "100%" }}
                    id="override-config"
                    label="Type Description"
                    value={asset.override_description || ""}
                    margin="normal"
                    onChange={(e) => {
                        dispatch({
                            type: actions.SET_OVERRIDE_DESCRIPTION,
                            payload: e.target.value,
                        });
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <FormControl className={classes.formControl} style={{ width: "100%" }}>
                    <InputLabel id="override-condition-label">Override Condition</InputLabel>
                    <Select
                        style={{ width: "100%" }}
                        id="override-condition-select"
                        labelId="override-condition-label"
                        value={asset.override_condition || ""}
                        onChange={(e) => {
                            dispatch({
                                type: actions.OVERRIDE_CONDITION,
                                payload: e.target.value,
                            });
                        }}>
                        <MenuItem value="New">New</MenuItem>
                        <MenuItem value="Used">Used</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            {
                asset?.type.includes("Truck") &&
                <Grid item xs={12}>
                    <TextField
                        style={{ width: "100%" }}
                        id="vehicle-mileage"
                        label="Vehicle Mileage"
                        value={asset?.override_mileage}
                        type="text"
                        margin="normal"
                        inputProps={{
                            maxLength: 7,
                        }}
                        onChange={(e) =>
                            dispatch({
                                type: actions.OVERRIDE_MILEAGE,
                                payload: e.target.value.replace(/[\D,-]/g, ''),
                            })
                        }
                    />
                </Grid>
            }
            {
                asset?.type.includes("Trailer") &&
                <Grid item xs={12}>
                    <TextField
                        style={{ width: "100%" }}
                        id="override-usage-hours"
                        label="Override Hours"
                        value={asset.override_hours}
                        type="text"
                        margin="normal"
                        inputProps={{
                            maxLength: 7,
                        }}
                        onChange={(e) => {
                            dispatch({
                                type: actions.OVERRIDE_HOURS,
                                payload: e.target.value.replace(/[\D,-]/g, ''),
                            });
                        }}
                    />
                </Grid>
            }
        </Grid>
    )
}
